import { useUserContext } from '@/auth/UserContext';
import { useStudyYearPeriods } from '@/pages/Overview/hooks/useStudyYearPeriods';
import { createCustomPeriod, getDefaultPeriod } from '@/pages/Overview/period';
import type { StudyYearPeriod } from '@/types/overview';
import { parseLocalDate } from '@/utils/date';

export const useStudyYearPeriod = (): StudyYearPeriod => {
  const { user } = useUserContext();
  const { periods } = useStudyYearPeriods();

  const defaultPeriod = getDefaultPeriod(periods);
  const { from, to } = user?.studyYear?.datePeriod ?? {};

  return createCustomPeriod(
    from ? parseLocalDate(from) : defaultPeriod.from,
    to ? parseLocalDate(to) : defaultPeriod.to,
  );
};
